import { useFilter, useSearchForm } from "@msuite/ui/hooks";
import { Loading } from "@msuite/ui/loading-screen";
import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import { guardString } from "@msuite/utils/strings";
import { SubstitutionPlanSummaryFilter } from "@/components/substitutions/substitution-plan-summary/substitution-plan-summary-filter";
import { SubstitutionPlanSummaryHeader } from "@/components/substitutions/substitution-plan-summary/substitution-plan-summary-header";
import { client } from "@/hono";
import { useAuth } from "@/hooks/use-auth";
import { SubstitutionPlanSummaryItem } from "./substitution-plan-summary-item";

/** Props Interface */
interface SubstitutionPlanSummaryProps {
	absenceId: string;
}

export function SubstitutionPlanSummary({ absenceId }: SubstitutionPlanSummaryProps) {
	/** Hooks */
	const auth = useAuth();
	const searchForm = useSearchForm();

	/** Query */
	const { data, isFetching } = useQuery({
		queryKey: ["substitution-plan", absenceId],
		queryFn: async () => {
			const response = await client.users[":userId"].substitutions[":absenceId"].summary.$get({
				param: {
					userId: guardString(auth.user?.id),
					absenceId,
				},
			});
			const data = await responseHandler(response);
			return data.summary;
		},
		staleTime: 0,
	});

	const { filtered } = useFilter(guardArray(data?.items), searchForm.searchValue);

	/** Render */
	return (
		<Loading isLoading={isFetching}>
			<SubstitutionPlanSummaryFilter searchForm={searchForm} />
			<SubstitutionPlanSummaryHeader />
			<div className="v-stack overflow-y-auto gap-0 card p-0 divide-y-[0.5px] *:border-color">
				{filtered.map((item) => (
					<SubstitutionPlanSummaryItem
						key={`${item.projectNumber}-${item.projectName}`}
						item={item}
					/>
				))}
			</div>
		</Loading>
	);
}
